module.exports = __webpack_public_path__ + "static/media/index-technology01.1bc2f97d.png";